//import external libraries
import * as React from "react";
import { useTranslation } from "react-i18next";
//import internal resources and services
import proluxLogo from "../../image/proluxLogoTransparent.png";
//import MUI components
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { useTheme } from "@mui/material/styles";

function Copyright() {
  const theme = useTheme();
  return (
    <Typography
      variant="body1"
      color={theme.palette.secondary.main}
      fontSize={18}
    >
      {"Copyright ©  "}
      Prolux {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

function Footer() {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Paper
      sx={{
        bottom: 0,
        width: "100%",
        // marginTop: "auto",
      }}
    >
      <footer
        className="footer"
        style={{ backgroundColor: theme.palette.primary.dark }}
      >
        {/*<div className="footer-left">
          <img src={proluxLogo} alt="logo" />
          <p className="footer-desc">{t("footer.description")}</p>
        </div>
        <ul className="footer-right">
          <li>
            <ul className="box">
              <li>
                <a
                  href="https://www.prolux-solutions.com/ch/de/produkte"
                  target="_blank"
                  rel="noreferrer"
                  className="footer-desc"
                >
                  {t("footer.product")}
                </a>
              </li>
              <li>
                <a
                  href="https://www.prolux-solutions.com/ch/de/referenzen"
                  target="_blank"
                  rel="noreferrer"
                  className="footer-desc"
                >
                  {t("footer.references")}
                </a>
              </li>
              <li>
                <a
                  href="https://www.prolux-solutions.com/ch/de/unterlagen"
                  target="_blank"
                  rel="noreferrer"
                  className="footer-desc"
                >
                  {t("footer.documents")}
                </a>
              </li>
            </ul>
          </li>
          <li className="features">
            <ul className="box">
              <li>
                <a
                  href="https://www.prolux-solutions.com/ch/de/ueber-uns/unternehmen"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t("footer.aboutUs")}
                </a>
              </li>
              <li>
                <a
                  href="https://www.prolux-solutions.com/ch/de/ueber-uns/team"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t("footer.team")}
                </a>
              </li>
              <li>
                <a
                  href="https://www.prolux-solutions.com/ch/de/ueber-uns/karriere"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t("footer.career")}
                </a>
              </li>
            </ul>
          </li>
          <li>
            <ul className="box">
              <li>
                <a
                  href="https://www.prolux-solutions.com/ch/de/ueber-uns/team"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t("footer.contactPersons")}
                </a>
              </li>

              <li>
                <a href="tel:+41714474848">+41 71 447 48 48</a>
              </li>
              <li>
                <a
                  href="mailto:info@prolux-ag.ch"
                  target="_blank"
                  rel="noreferrer"
                >
                  info@prolux-ag.ch
                </a>
              </li>
            </ul>
          </li>
          <li>
            <ul className="box">
              <li>
                <a
                  href="https://www.prolux-solutions.com/ch/de/ueber-uns/newsletter"
                  target="_blank"
                  rel="noreferrer"
                >
                  Newsletter
                </a>
              </li>
              <li>
                <div
                  className="socials"
                  style={{
                    display: "flex",
                    // gap: "35px",
                    justifyContent: "start",
                    position: "relative",
                    left: "-5px",
                  }}
                >
                  <a
                    href="https://www.linkedin.com/company/termovent-komerc"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <LinkedInIcon
                      sx={{
                        color: theme.palette.secondary.main,
                        width: "40px",
                        height: "30px",
                      }}
                    />
                  </a>
                  <a
                    href="https://www.youtube.com/user/termovent"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <YouTubeIcon
                      sx={{
                        color: theme.palette.secondary.main,
                        width: "40px",
                        height: "30px",
                      }}
                    />
                  </a>
                </div>
              </li>
            </ul>
          </li>
        </ul>*/}
        <div style={{ textAlign: "center", width: "100%" }}>
        </div>
        <div className="footer-bottom">
          <Copyright />
        </div>
      </footer>
    </Paper>
  );
}

export default Footer;
